import { render, staticRenderFns } from "./ot-specific-modals-wrapper.vue?vue&type=template&id=9715a0aa&scoped=true&"
import script from "./ot-specific-modals-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-specific-modals-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-specific-modals-wrapper.vue?vue&type=style&index=0&id=9715a0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9715a0aa",
  null
  
)

export default component.exports